import { EnterIcon, IconButton } from "@minervaproject/fds";
import React from "react";

import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { visitBreakoutRoom } from "shared/reducers/classroom";
import { BreakoutRoomType } from "shared/types";
import { localSelectors } from "store";

function VisitButton({
  breakoutRoom,
  showButtonText = false,
}: {
  breakoutRoom: BreakoutRoomType;
  showButtonText?: boolean;
}) {
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());

  const handleVisitBreakoutRoom = () => {
    dispatch(visitBreakoutRoom({ userId: currentUserId, breakoutRoomId: breakoutRoom.id }));
  };

  return (
    <IconButton
      onClick={handleVisitBreakoutRoom}
      aria-label={`Visit Breakout Group ${breakoutRoom.title}`}
    >
      <EnterIcon width={16} height={16} />
      {showButtonText && <span className="text-black-tint-70 body-xs bold ml1">Visit</span>}
    </IconButton>
  );
}

export { VisitButton };
